import React, { useContext, useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Row, Modal, ModalBody, ModalHeader, ModalFooter, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import classnames from "classnames";
import { GolbalDataContext } from '../../components/store/global-data-provider';
import ConfigData from "../../config.json";
import MultipleUploadfile from '../../components/common/multiple-uploadfile';
import SingleUploadfile from '../../components/common/single-uploadfile';
import { getFilterOldFileName, setFormDataUploadFile, setStringFileNameToArray } from '../../components/utils/format-value';
import MultipleDownloadfile from '../../components/common/multiple-downloadfile';
import StepWorkflow from '../../components/common/step-workflow';
import Swal from 'sweetalert2';
import { IconAlertSuccess, IconAlertError, IconLoading } from '../../components/common/popup-alert';
import RequestFormCsa from "../../components/request/requestForm/request_form_csa";
import RequestFormNda from "../../components/request/requestForm/request_form_nda";
import RequestFormLdr from "../../components/request/requestForm/request_form_ldr";
import RequestFormDbd from "../../components/request/requestForm/request_form_dbd";
import RequestFormPoa from "../../components/request/requestForm/request_form_poa";
import RequestFormGct from "../../components/request/requestForm/request_form_gct";
import { ConvertStringDate } from '../../components/utils/convert-date';
import AssignDetailCsa from '../../components/assign/assign-detail-csa';
import AssignDetailNda from '../../components/assign/assign-detail-nda';
import AssignDetailLdr from '../../components/assign/assign-detail-ldr';
import AssignDetailDbd from '../../components/assign/assign-detail-dbd';
import AssignDetailPoa from '../../components/assign/assign-detail-poa';
import RequestHistory from '../../components/request/request-history';

const Memo = () => {
    const { id } = useParams();
    const history = useHistory();
    const { changeTitlePage } = useContext(GolbalDataContext);
    const [isUserFinalDoc, setIsUserFinalDoc] = useState(null);
    const [templateMemo, setTemplateMemo] = useState([]);
    const [fileUserFinalDoc, setFileUserFinalDoc] = useState([]);
    const [disableFileUserFinalDoc, setDisableFileUserFinalDoc] = useState(true);
    const [fileMemoDoc, setFileMemoDoc] = useState([]);
    const [fileAgreementDoc, setFileAgreementDoc] = useState([]);
    const [isShowModal, setIsShowModal] = useState();
    const [dataForm, setDataForm] = useState([]);
    const [dataFormRequest, setDataFormRequest] = useState([]);
    const [requestHistory, setRequestHistory] = useState([]);
    const [dataUser, setDataUser] = useState([]);
    const [userCreateRequest, setUserCreateRequest] = useState([]);
    const [userBuDetail, setUserBuDetail] = useState([]);
    const [customActiveTab, setcustomActiveTab] = useState("2");
    const [formIsDisabled, setFormIsDisabled] = useState(false);
    const [dataRequest, setDataRequest] = useState({
        "id": 0,
        "request_no": "",
        "is_user_final_doc": "",
        "final_doc": "-",
        "memo_doc": "",
        "agreement_doc": "",
        "note": "",
        "send_to": ""
    });

    useEffect(() => {
        changeTitlePage("All Request");
        let strId = "0";
        try{
            strId = atob(id);
        }catch(error){
            strId = "0"
        }
        LoadUserCanDoReq(strId);
        LoadDataTemplateMemo();
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataRequest.id || 0,
            request_no: dataRequest.request_no || 0,
            is_user_final_doc: dataRequest.is_user_final_doc || "",
            final_doc: dataRequest.final_doc || "",
            memo_doc: dataRequest.memo_doc || "",
            agreement_doc: dataRequest.agreement_doc || "",
            note: dataRequest.note || "",
            send_to: dataRequest.send_to || "",
        },
        validationSchema: Yup.object({
            is_user_final_doc: Yup.string().required("กรุณาเลือกวิธีการทำเอกสารสุดท้าย/Please select document finalization option"),
            final_doc: Yup.string().required("กรุณาแนบไฟล์เอกสาร/Please attach file"),
            memo_doc: Yup.string().required("กรุณาแนบไฟล์ Memo ที่ลงนามแล้ว/Please attach the signed Memo"),
        }),
        onSubmit: (values) => {
            SaveMemo(values);
        }
    });
    
    const OnSetFileAgreementDoc = (files) => {
        setFileAgreementDoc(files);
        setFormIsDisabled(false);
    };

    const OnSetFileMemoDoc = (file) => {
        const fileName = (file.length > 0) ? file[0].name : "";
        setFileMemoDoc(file);
        validation.handleChange('memo_doc')(fileName);
        setFormIsDisabled(false);
    };

    const OnSetFileUserFinalDoc = (file) => {
        if(isUserFinalDoc === true){
            const fileName = (file.length > 0) ? file[0].name : "";
            setFileUserFinalDoc(file);
            validation.handleChange('final_doc')(fileName);
        }else{
            setFileUserFinalDoc([]);
            validation.handleChange('final_doc')("-");
        }
        setFormIsDisabled(false);
    };

    const OnClickBack = () => {
        // history.push("/dashboard");
        history.push(GetUrlBack());
    };

    const onSaveForm = (data) => {
        // console.log(data);

        let isSaveSucess = true;
            // console.log(data);
            (async () => {
                try{
                    let getDataForm;
                    let newFormatStartDate = null;
                    let newFormatEndDate = null;
                   
                    if(data.business_unit_other !== "" && data.id_business_unit === "-1") {
                        
                        const postdataRequest = {
                            ...data,
                            id: data.id,
                            id_business_unit : data.business_unit_other !== "" ? "-1" : data.id_business_unit,
                            business_unit_other : data.business_unit_other,
                            id_confidential_level: data.id_confidential_level,
                        };
                        let dataUpdateRequestDraft = await UpdateRequests(postdataRequest);
                        isSaveSucess = (dataUpdateRequestDraft.is_sucess === true && isSaveSucess === true) ? true : false;
                        // console.log(dataUpdateRequestDraft);
                        
                        if( dataFormRequest.table_name?.toLowerCase() === "csa" ){
                            if(data.term_start_date !== null && data.term_end_date !== null){
                                // Convert term_start_date format
                               const [startDay, startMonth, startYear] = data.term_start_date.split('/');
                               const formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
                               newFormatStartDate = formattedStartDate.replace(/undefined-/g, '');
                               // Convert term_end_date format
                               const [endDay, endMonth, endYear] = data.term_end_date.split('/');
                               const formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
                               newFormatEndDate = formattedEndDate.replace(/undefined-/g, '');
                            }
                            const updatedDataCompany = {
                                ...data,
                                id_business_unit: dataUpdateRequestDraft.data[0].id_business_unit,
                                term_start_date:newFormatStartDate,
                                term_end_date:newFormatEndDate,
                            };
                            getDataForm = await UpdateForm(updatedDataCompany, "csa");
                        } else if( dataFormRequest.table_name?.toLowerCase() === "nda" ){
                            const updatedDataCompany = {
                                ...data,
                                id_business_unit: dataUpdateRequestDraft.data[0].id_business_unit,
                            };
                            getDataForm = await UpdateForm(updatedDataCompany, "nda");
                        } else if( dataFormRequest.table_name?.toLowerCase() === "dbd" ){
                            const updatedDataCompany = {
                                ...data,
                                id_business_unit: dataUpdateRequestDraft.data[0].id_business_unit,
                            };
                            getDataForm = await UpdateForm(updatedDataCompany, "dbd");
                        }
                    } else {
                        const postdataRequest = {
                            ...dataRequest,
                            id: data.id,
                            id_business_unit : data.business_unit_other !== "" ? "-1" : data.id_business_unit,
                            business_unit_other : data.business_unit_other,
                            id_confidential_level: data.id_confidential_level,
                        };
                        // console.log(postdataRequest);
                        let dataUpdateRequestDraft = await UpdateRequests(postdataRequest);
                        isSaveSucess = (dataUpdateRequestDraft.is_sucess === true && isSaveSucess === true) ? true : false;
                        
                        if( dataFormRequest.table_name?.toLowerCase() === "csa" ){
                            if(data.term_start_date !== null && data.term_end_date !== null){
                                // Convert term_start_date format
                               const [startDay, startMonth, startYear] = data.term_start_date.split('/');
                               const formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
                               newFormatStartDate = formattedStartDate.replace(/undefined-/g, '');
                               // Convert term_end_date format
                               const [endDay, endMonth, endYear] = data.term_end_date.split('/');
                               const formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
                               newFormatEndDate = formattedEndDate.replace(/undefined-/g, '');
                            }
                            const updatedForm = {
                                ...data,
                                term_start_date:newFormatStartDate,
                                term_end_date:newFormatEndDate,
                            };
                            getDataForm = await UpdateForm(updatedForm, "csa");
                        } else if( dataFormRequest.table_name?.toLowerCase() === "nda" ){
                            getDataForm = await UpdateForm(data, "nda");
                        } else if( dataFormRequest.table_name?.toLowerCase() === "dbd" ){
                            getDataForm = await UpdateForm(data, "dbd");
                        }
                    }
                    
                    isSaveSucess = (getDataForm.is_sucess === true && isSaveSucess === true) ? true : false;
                    // console.log(dataFormCsa);

                    let isFileName = await SetFileName(getDataForm.data[0].id, data.request_no, data, dataFormRequest.table_name?.toLowerCase());
                    isSaveSucess = (isFileName === true && isSaveSucess === true) ? true : false;
                    // console.log(isSaveSucess);
                    
                    if(isSaveSucess === true){
                        Swal.fire({
                            iconHtml: IconAlertSuccess,
                            title: "Save success.",
                            showConfirmButton: false,
                            showCloseButton: true,
                            // showConfirmButton: false,
                        }).then(() => {
                            setIsShowModal(false);
                            LoadDataRequest(atob(id));
                            // props.nextStep();
                            // history.push("/request/" + btoa(dataAddRequest.data[0].id));
                        });
                    }else{
                        Swal.fire({
                            iconHtml: IconAlertError,
                            title: "Failed to save data.",
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                    }
                } catch(error){
                    console.log(error);
                }
            })();
    };

    const onSaveFormTrans = (data) => {
        let formData = new FormData();
        let isForm = "";
        let reqDate = ConvertStringDate(dataFormRequest.request_date, "dd/MM/yyyy", "yyyy-MM-dd", "/");
        const postdataRequest = {
            ...dataFormRequest,
            request_date: reqDate,
            memo_doc: data.memo_doc ?? ""
        };
        formData.append("requestData", JSON.stringify(postdataRequest));

        if( dataFormRequest.table_name?.toLowerCase() === "ldr" ){
            isForm = "ldr";
            const postDataFormLdr = {
                ...data,
            };
            formData.append("formLdrData", JSON.stringify(postDataFormLdr));
            formData = setFormDataUploadFile(formData, "f_for_use_doc", data.file_for_use_doc);
            formData = setFormDataUploadFile(formData, "f_memo_doc", data.file_memo_doc);
        }else if( dataFormRequest?.table_name.toLowerCase() === "poa" ){
            isForm = "poa";
            const postDataFormPoa = {
                ...data,
            };
            formData.append("formPoaData", JSON.stringify(postDataFormPoa));
            formData = setFormDataUploadFile(formData, "f_purpose_poa_doc", data.file_purpose_poa_doc);
            formData = setFormDataUploadFile(formData, "f_attorney_doc", data.file_attorney_doc);
            formData = setFormDataUploadFile(formData, "f_detail_poa_doc", data.file_detail_poa_doc);
            formData = setFormDataUploadFile(formData, "f_form_other_poa_doc", data.file_form_other_poa_doc);
        } else if( dataFormRequest.table_name?.toLowerCase() === "gct" ){
            isForm = "gct";

            const postDataFormGct = {
                ...data,
                id_confidential_level: data.id_confidential_level ? parseInt(data.id_confidential_level) : null,
            };
            formData.append("formGctData", JSON.stringify(postDataFormGct));
            formData = setFormDataUploadFile(formData, "f_req_legal_team_to_doc", data.file_req_legal_team_to_doc);
            formData = setFormDataUploadFile(formData, "f_counterparty_doc", data.file_counterparty_doc);
            formData = setFormDataUploadFile(formData, "f_detail_contract_doc", data.file_detail_contract_doc);
        } else if( dataFormRequest.table_name.toLowerCase() === "csa" ){
            isForm = "csa";
            // set date to post formcsa
            const postDataFormCsa = {
                ...data,
                id_confidential_level: data.id_confidential_level !== "" ? data.id_confidential_level : "0",
                id_business_unit : (data.id_business_unit !== null && data.id_business_unit !== undefined && data.id_business_unit !== "") ? data.id_business_unit.toString() : "0",
            };
            formData.append("formCsaData", JSON.stringify(postDataFormCsa));
            formData = setFormDataUploadFile(formData, "f_draft_doc", data.file_draft_doc);
            formData = setFormDataUploadFile(formData, "f_counterparty_doc", data.file_counterparty_doc);
            formData = setFormDataUploadFile(formData, "f_is_sla_doc", data.file_is_sla_doc);
            formData = setFormDataUploadFile(formData, "f_scope_of_work_doc", data.file_scope_of_work_doc);
            formData = setFormDataUploadFile(formData, "f_consider_doc", data.file_consider_doc);  
        }else if( dataFormRequest.table_name.toLowerCase() === "nda" ){
            isForm = "nda";
            const postDataFormNda = {
                ...data,
                id_confidential_level: data.id_confidential_level !== "" ? data.id_confidential_level : "0",
                id_business_unit : (data.id_business_unit !== null && data.id_business_unit !== undefined && data.id_business_unit !== "") ? data.id_business_unit.toString() : "0",
            };
            formData.append("formNdaData", JSON.stringify(postDataFormNda));
            formData = setFormDataUploadFile(formData, "f_draft_doc", data.file_draft_doc);
            formData = setFormDataUploadFile(formData, "f_consider_doc", data.file_consider_doc);
        } else if( dataFormRequest.table_name.toLowerCase() === "dbd" ){
            isForm = "dbd";
            const postDataFormDbd = {
                ...data,
                id_confidential_level: data.id_confidential_level ? parseInt(data.id_confidential_level) : null,
                id_business_unit: data.id_business_unit ? String(data.id_business_unit) : null,
            };
            formData.append("formDbdData", JSON.stringify(postDataFormDbd));
            formData = setFormDataUploadFile(formData, "f_edit_seal", data.file_edit_seal);
            formData = setFormDataUploadFile(formData, "f_headoffice_file", data.file_headoffice_file);
            formData = setFormDataUploadFile(formData, "f_branchoffice_ic_file_1", data.file_branchoffice_ic_file_1);
            formData = setFormDataUploadFile(formData, "f_branchoffice_ic_file_2", data.file_branchoffice_ic_file_2);
            formData = setFormDataUploadFile(formData, "f_branchoffice_ic_file_3", data.file_branchoffice_ic_file_3);
            formData = setFormDataUploadFile(formData, "f_branchoffice_ic_file_4", data.file_branchoffice_ic_file_4);
            formData = setFormDataUploadFile(formData, "f_branchoffice_ic_file_5", data.file_branchoffice_ic_file_5);
            formData = setFormDataUploadFile(formData, "f_objective_add_file", data.file_objective_add_file);
            formData = setFormDataUploadFile(formData, "f_objective_edit_file", data.file_objective_edit_file);
            formData = setFormDataUploadFile(formData, "f_bylaws_add_file", data.file_bylaws_add_file);
            formData = setFormDataUploadFile(formData, "f_bylaws_edit_file", data.file_bylaws_edit_file);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_1", data.file_cod_add_file_1);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_2", data.file_cod_add_file_2);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_3", data.file_cod_add_file_3);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_4", data.file_cod_add_file_4);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_5", data.file_cod_add_file_5);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_6", data.file_cod_add_file_6);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_7", data.file_cod_add_file_7);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_8", data.file_cod_add_file_8);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_9", data.file_cod_add_file_9);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_10", data.file_cod_add_file_10);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_1", data.file_ts_ctp_file_1);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_2", data.file_ts_ctp_file_2);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_3", data.file_ts_ctp_file_3);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_4", data.file_ts_ctp_file_4);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_5", data.file_ts_ctp_file_5);
            formData = setFormDataUploadFile(formData, "f_dtc_liquidatoroffice_file", data.file_dtc_liquidatoroffice_file);
            formData = setFormDataUploadFile(formData, "f_col_balancesheet_file", data.file_col_balancesheet_file);
            formData = setFormDataUploadFile(formData, "f_col_docs_file", data.file_col_docs_file);
        }
        // UpdateFormTrans
        Swal.fire({
            icon: 'info',
            title: 'Loading...',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });

        let isSaveSucess = true;
        (async() => {
            try{
                let requestData = await UpdateFormTrans(dataFormRequest.id, formData, isForm);
                isSaveSucess = (requestData.is_sucess === true && isSaveSucess === true) ? true : false;

                if(isSaveSucess === true){
                    Swal.close(); // Close loading spinner
                    Swal.fire({
                        iconHtml: IconAlertSuccess,
                        title: "Save success.",
                        showConfirmButton: false,
                        showCloseButton: true,
                        // showConfirmButton: false,
                    }).then(() => {
                        setIsShowModal(false);
                        LoadDataRequest(dataFormRequest.id);
                    });
                } else {
                    Swal.close(); // Close loading spinner
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "Failed to save data.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } catch(error) {
                Swal.close(); // Close loading spinner
                Swal.fire({
                    iconHtml: IconAlertError,
                    title: "Failed to save data.",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
                console.log(error);
            }
        })();
    };

    const CheckDisableForm = (isDisable, elementName) => {
        if(isDisable === true){
            if(dataFormRequest.table_name?.toLowerCase() === "ldr"){
                return true;
            }else if(dataFormRequest.table_name?.toLowerCase() === "poa"){
                if(elementName === "is_user_final_doc"){
                    return true;
                }
            }
        }
        return false;
    };

    const toggleCustomActiveTab = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const showLoading = (isShow) => {
        if (isShow) {
            Swal.fire({
                iconHtml: IconLoading,
                title: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });
        } else {
            Swal.close();           
        }
    };

    const SwitchRequestDetail = () => {
        switch (dataFormRequest.table_name?.toLowerCase()) {
            case "csa": 
                return (
                    <AssignDetailCsa 
                        requestDetail={dataFormRequest}
                        requestTemplateDetail={dataForm}
                    />
                );
            case "nda": 
                return (
                    <AssignDetailNda
                        requestDetail={dataFormRequest}
                        requestTemplateDetail={dataForm}
                    />
                );
            case "ldr": 
                return (
                    <AssignDetailLdr
                        requestDetail={dataFormRequest}
                        requestTemplateDetail={dataForm}
                    />
                );
            case "dbd": 
                return (
                    <AssignDetailDbd
                        requestDetail={dataFormRequest}
                        requestTemplateDetail={dataForm}
                    />
                );
            case "poa": 
                return (
                    <AssignDetailPoa
                        requestDetail={dataFormRequest}
                        requestTemplateDetail={dataForm}
                    />
                );
            default: 
                return (
                    <div></div>
                );
        }
    };

    const GetUrlBack = () => {
        const urlBack = (dataFormRequest.table_name !== "" && dataFormRequest.table_name !== null && dataFormRequest.table_name !== undefined) ? "/request-form/" + btoa(dataFormRequest.table_name) : "/all-type-request";
        return urlBack;
    };

    const checkShowInputUserCoordinator = (
        (userCreateRequest.business_unit?.toLowerCase() !== "bts group holdings public company limited") 
    );

    const LoadDataRequest = (id) => {
        let url = ConfigData.API_URL + "request/" + id ;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                let isUserFinalDoc = respData.data[0].is_user_final_doc;
                let finalDoc = respData.data[0].final_doc
                if((respData.data[0].table_name.toLowerCase() === "ldr" 
                    || respData.data[0].table_name.toLowerCase() === "poa") 
                    && isUserFinalDoc === ""){
                    isUserFinalDoc = "0";
                }
                if((respData.data[0].table_name.toLowerCase() === "ldr" 
                    || respData.data[0].table_name.toLowerCase() === "poa")
                    && finalDoc === ""){
                    finalDoc = "-";
                }
                
                const objData = {
                    "id": respData.data[0].id,
                    "request_no": respData.data[0].request_no,                
                    "is_user_final_doc": isUserFinalDoc,
                    "final_doc": finalDoc,
                    "memo_doc": respData.data[0].memo_doc,
                    "agreement_doc": respData.data[0].agreement_doc,
                    "send_to": respData.data[0].accept_request_by,
                    "note": ""
                };
                LoadDataReqWorkflowStatus(respData.data[0].id, 15, objData);
                setIsUserFinalDoc((objData.is_user_final_doc === "1") ? true : (objData.is_user_final_doc === "0") ? false : null);
                setFileUserFinalDoc(setStringFileNameToArray((objData.final_doc === "-") ? "" : objData.final_doc));
                setFileMemoDoc(setStringFileNameToArray(objData.memo_doc));
                setFileAgreementDoc(setStringFileNameToArray(objData.agreement_doc));
                LoadProfileUser(respData.data[0].request_by);
                if(respData.data[0]?.create_request_by !== ""){
                    LoadUserCreateRequest(respData.data[0]?.create_request_by);
                }
                setDataFormRequest(respData.data[0]);
                if( respData.data[0].table_name?.toLowerCase() === "csa" ){
                    LoadDataForm(respData.data[0].id, "csa");
                } else if( respData.data[0].table_name?.toLowerCase() === "nda" ){
                    LoadDataForm(respData.data[0].id, "nda");
                } else if( respData.data[0].table_name?.toLowerCase() === "ldr" ){
                    LoadDataForm(respData.data[0].id, "ldr");
                } else if( respData.data[0].table_name?.toLowerCase() === "dbd" ){
                    LoadDataForm(respData.data[0].id, "dbd");
                } else if( respData.data[0].table_name?.toLowerCase() === "poa" ){
                    LoadDataForm(respData.data[0].id, "poa");
                } else if( respData.data[0].table_name?.toLowerCase() === "gct" ){
                    LoadDataForm(respData.data[0].id, "gct");
                }
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataForm = (idRequests, formName) => {
        let url;
        if( formName === "csa" ){
            url = ConfigData.API_URL + "form-csa/request/" + idRequests;
        } else if( formName === "nda" ){
            url = ConfigData.API_URL + "form-nda/request/" + idRequests;
        } else if( formName === "ldr" ){
            url = ConfigData.API_URL + "form-ldr/request/" + idRequests;
        } else if( formName === "dbd" ){
            url = ConfigData.API_URL + "form-dbd/request/" + idRequests;
        } else if( formName === "poa" ){
            url = ConfigData.API_URL + "form-poa/request/" + idRequests;
        } else if( formName === "gct" ){
            url = ConfigData.API_URL + "form-gct/request/" + idRequests;
        }

        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const arrData = respData.data[0];
                setDataForm(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadProfileUser = (email) => {
        let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataUser(respData.data[0]);
                LoadUserBuInfo(respData.data[0].id_business_unit);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadUserCreateRequest = (email) => {
        //console.log(email);
        let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            // console.log(respData);
            if(respData.is_sucess === true && respData.data.length > 0){
                setUserCreateRequest(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadUserBuInfo = (buId) => {
        let url = ConfigData.API_URL + "business-unit/" + buId;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios
          .get(url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            responseType: "json",
          })
          .then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
              setUserBuDetail(respData.data[0]);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    };

    const LoadDataReqWorkflowStatus = (idReq, idWorkflowStatus, objReq) => {
        let url = ConfigData.API_URL + "request-workflow/search?status=1&idRequest=" + idReq  + "&idWorkflowStatus=" + idWorkflowStatus;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                objReq.note = respData.data[0].comment;
            }
            setDataRequest(objReq);
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
            setDataRequest(objReq);
        });
    };

    const LoadDataTemplateMemo = () => {
        let url = ConfigData.API_URL + "memo/search?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setTemplateMemo(respData.data);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadUserCanDoReq = (id) => {
        let userDo = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let url = new URL(ConfigData.API_URL + "request/user-can-do");
        url.searchParams.set("email", userDo);
        url.searchParams.set("id-request", id);
        url.searchParams.set("id-workflow", "10"); 
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const arrUserDo = respData.data[0].user_do_request.split(",");
                if(arrUserDo.find((e) => e === userDo) !== undefined){
                    LoadDataRequest(id);
                    LoadRequestHistory(id);
                }else{
                    history.push("/summary-request/" + btoa(id));
                    // sample request
                    // LoadDataRequest(22);
                }
            }else{
                // history.push("/dashboard");
                history.push(GetUrlBack());
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadRequestHistory = (idReq) => {
        let url = ConfigData.API_URL + "request-workflow/search?status=1&idRequest=" + idReq;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },responseType: "json",
        }).then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setRequestHistory(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const SaveMemo = (values) => {
        if(values.id > 0){
            showLoading(true);
            let isSaveSucess = true;
            (async () => {
                let isSaveMemo = await UpdateMemo(values);
                isSaveSucess = (isSaveMemo === true && isSaveSucess === true) ? true : false;
                let isSaveReqWorkflowStatus = await AddWorkFlowStaus(values);
                isSaveSucess = (isSaveReqWorkflowStatus === true && isSaveSucess === true) ? true : false;
                if(isSaveSucess === true){
                    SendEmail(values);
                    showLoading(false);
                    Swal.fire({
                        iconHtml: IconAlertSuccess,
                        title: "อยู่ระหว่างส่งข้อมูลนี้ไปยังฝ่ายกฏหมาย\nSending the information to legal team",
                        showConfirmButton: false,
                        showCloseButton: true,
                    }).then(() => {
                        // history.push("/dashboard");
                        history.push(GetUrlBack());
                    });
                }else{
                    showLoading(false);
                }
            })();
        }
    };

    const cancelRequest = (value) => {
        setIsShowModal(value);
    };

    const UpdateMemo = async (data) => {
        const url = ConfigData.API_URL + "request/memo/" + data.id;
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let formData = new FormData();
        formData.append("request_no", data.request_no);
        formData.append("is_user_final_doc", data.is_user_final_doc);
        formData.append("n_final_doc", getFilterOldFileName(fileUserFinalDoc));
        formData.append("n_memo_doc", getFilterOldFileName(fileMemoDoc));
        formData.append("n_agreement_doc", getFilterOldFileName(fileAgreementDoc));
        formData = setFormDataUploadFile(formData, "f_final_doc", fileUserFinalDoc);
        formData = setFormDataUploadFile(formData, "f_memo_doc", fileMemoDoc);
        formData = setFormDataUploadFile(formData, "f_agreement_docs", fileAgreementDoc);
        try{
            const resp = await axios.put(url, formData, { headers: { 
                'Content-Type': 'multipart/form-data',
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            console.log(error);
            return false;
        }
    };

    const UpdateRequests = async (data) => {
        let url = ConfigData.API_URL + "request/" + data.id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url, data, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const UpdateForm = async (data, formName) => {
        let url;
        if( formName === "csa" ){
            url = ConfigData.API_URL + "form-csa/" + data.id;
            if(data.term_start_date === ""){
                data.term_start_date = null;
            }  
            if(data.term_end_date === ""){
                data.term_end_date = null;
            }  
            if(data.id_confidential_level === ""){
                data.id_confidential_level = "0";
            }   
        } else if( formName === "nda" ){
            url = ConfigData.API_URL + "form-nda/" + data.id;
            if(data.id_confidential_level === ""){
                data.id_confidential_level = "0";
            }   
        } else if( formName === "dbd" ){
            url = ConfigData.API_URL + "form-dbd/" + data.id;
            if(data.id_confidential_level === ""){
                data.id_confidential_level = "0";
            }   
            data.id_confidential_level = parseInt(data.id_confidential_level);
        }
        
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url, data, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            // console.log(respData);
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const UpdateFormTrans = async (requsetId, formData, formName) => {
        let url;
        if( formName === "ldr" ){
            url = ConfigData.API_URL + "request/update-ldr-draft-trans/" + requsetId;
        }else if( formName === "poa" ){
            url = ConfigData.API_URL + "request/update-poa-draft-trans/" + requsetId;
        } else if( formName === "gct" ){
            url = ConfigData.API_URL + "request/update-gct-draft-trans/" + requsetId;
        } else if( formName === "csa" ){
            url = ConfigData.API_URL + "request/update-csa-draft-trans/" + requsetId;
        } else if( formName === "nda" ){
            url = ConfigData.API_URL + "request/update-nda-draft-trans/" + requsetId;
        } else if( formName === "dbd" ){
            url = ConfigData.API_URL + "request/update-dbd-draft-trans/" + requsetId;
        }
        
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url, formData, { headers: { 
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const SetFileName = async (id, requestNo, data, formName) => {
        let url;
        let formData = new FormData();
        formData.append("request_no", requestNo);
        if( formName === "csa" ){
            url = ConfigData.API_URL + "form-csa/set-filename/" + id;
            formData.append("n_draft_doc", getFilterOldFileName(data.file_draft_doc));
            formData.append("n_counterparty_doc", getFilterOldFileName(data.file_counterparty_doc));
            formData.append("n_is_sla_doc", getFilterOldFileName(data.file_is_sla_doc));
            formData.append("n_scope_of_work_doc", getFilterOldFileName(data.file_scope_of_work_doc));
            formData.append("n_consider_doc", getFilterOldFileName(data.file_consider_doc));
            formData = setFormDataUploadFile(formData, "f_draft_doc", data.file_draft_doc);
            formData = setFormDataUploadFile(formData, "f_counterparty_doc", data.file_counterparty_doc);
            formData = setFormDataUploadFile(formData, "f_is_sla_doc", data.file_is_sla_doc);
            formData = setFormDataUploadFile(formData, "f_scope_of_work_doc", data.file_scope_of_work_doc);
            formData = setFormDataUploadFile(formData, "f_consider_doc", data.file_consider_doc);
        } else if( formName === "nda" ){
            url = ConfigData.API_URL + "form-nda/set-filename/" + id;
            formData.append("n_draft_doc", getFilterOldFileName(data.file_draft_doc));
            formData.append("n_consider_doc", getFilterOldFileName(data.file_consider_doc));
            formData = setFormDataUploadFile(formData, "f_draft_doc", data.file_draft_doc);
            formData = setFormDataUploadFile(formData, "f_consider_doc", data.file_consider_doc);
        }else if( formName === "dbd" ){
            url = ConfigData.API_URL + "form-dbd/set-filename/" + id;

            formData.append("n_edit_seal", getFilterOldFileName(data.file_edit_seal));
            formData.append("n_headoffice_file", getFilterOldFileName(data.file_headoffice_file));
            formData.append("n_branchoffice_ic_file", getFilterOldFileName(data.file_branchoffice_ic_file));
            formData.append("n_objective_add_file", getFilterOldFileName(data.file_objective_add_file));
            formData.append("n_objective_edit_file", getFilterOldFileName(data.file_objective_edit_file));
            formData.append("n_bylaws_add_file", getFilterOldFileName(data.file_bylaws_add_file));
            formData.append("n_bylaws_edit_file", getFilterOldFileName(data.file_bylaws_edit_file));
            formData.append("n_cod_add_file_1", getFilterOldFileName(data.file_cod_add_file_1));
            formData.append("n_cod_add_file_2", getFilterOldFileName(data.file_cod_add_file_2));
            formData.append("n_cod_add_file_3", getFilterOldFileName(data.file_cod_add_file_3));
            formData.append("n_cod_add_file_4", getFilterOldFileName(data.file_cod_add_file_4));
            formData.append("n_cod_add_file_5", getFilterOldFileName(data.file_cod_add_file_5));
            formData.append("n_cod_add_file_6", getFilterOldFileName(data.file_cod_add_file_6));
            formData.append("n_cod_add_file_7", getFilterOldFileName(data.file_cod_add_file_7));
            formData.append("n_cod_add_file_8", getFilterOldFileName(data.file_cod_add_file_8));
            formData.append("n_cod_add_file_9", getFilterOldFileName(data.file_cod_add_file_9));
            formData.append("n_cod_add_file_10", getFilterOldFileName(data.file_cod_add_file_10));
            formData.append("n_ts_ctp_file_1", getFilterOldFileName(data.file_ts_ctp_file_1));
            formData.append("n_ts_ctp_file_2", getFilterOldFileName(data.file_ts_ctp_file_2));
            formData.append("n_ts_ctp_file_3", getFilterOldFileName(data.file_ts_ctp_file_3));
            formData.append("n_ts_ctp_file_4", getFilterOldFileName(data.file_ts_ctp_file_4));
            formData.append("n_ts_ctp_file_5", getFilterOldFileName(data.file_ts_ctp_file_5));
            formData.append("n_dtc_liquidatoroffice_file", getFilterOldFileName(data.file_dtc_liquidatoroffice_file));
            formData.append("n_col_balancesheet_file", getFilterOldFileName(data.file_col_balancesheet_file));
            formData.append("n_col_docs_file", getFilterOldFileName(data.file_col_docs_file));
            formData = setFormDataUploadFile(formData, "f_edit_seal", data.file_edit_seal);
            formData = setFormDataUploadFile(formData, "f_headoffice_file", data.file_headoffice_file);
            formData = setFormDataUploadFile(formData, "f_branchoffice_ic_file", data.file_branchoffice_ic_file);
            formData = setFormDataUploadFile(formData, "f_objective_add_file", data.file_objective_add_file);
            formData = setFormDataUploadFile(formData, "f_objective_edit_file", data.file_objective_edit_file);
            formData = setFormDataUploadFile(formData, "f_bylaws_add_file", data.file_bylaws_add_file);
            formData = setFormDataUploadFile(formData, "f_bylaws_edit_file", data.file_bylaws_edit_file);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_1", data.file_cod_add_file_1);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_2", data.file_cod_add_file_2);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_3", data.file_cod_add_file_3);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_4", data.file_cod_add_file_4);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_5", data.file_cod_add_file_5);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_6", data.file_cod_add_file_6);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_7", data.file_cod_add_file_7);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_8", data.file_cod_add_file_8);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_9", data.file_cod_add_file_9);
            formData = setFormDataUploadFile(formData, "f_cod_add_file_10", data.file_cod_add_file_10);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_1", data.file_ts_ctp_file_1);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_2", data.file_ts_ctp_file_2);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_3", data.file_ts_ctp_file_3);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_4", data.file_ts_ctp_file_4);
            formData = setFormDataUploadFile(formData, "f_ts_ctp_file_5", data.file_ts_ctp_file_5);
            formData = setFormDataUploadFile(formData, "f_dtc_liquidatoroffice_file", data.file_dtc_liquidatoroffice_file);
            formData = setFormDataUploadFile(formData, "f_col_balancesheet_file", data.file_col_balancesheet_file);
            formData = setFormDataUploadFile(formData, "f_col_docs_file", data.file_col_docs_file);
        }
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));

        try{
            const resp = await axios.put(url, formData, { headers: { 
                'Content-Type': 'multipart/form-data',
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            // console.log(respData);
            return respData.is_sucess;
        }catch(error){
            console.log(error);
            return false;
        }
    };

    const AddWorkFlowStaus = async (dataReq) => {
        const url = ConfigData.API_URL + "request-workflow/step";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try{
            let formData = new FormData();
            formData.append("id_request", dataReq.id);
            formData.append("id_workflow_status", "15");
            formData.append("do_by", userId);
            formData.append("send_to", dataReq.send_to);
            formData.append("comment", dataReq.note);
            const resp = await axios.post(url, formData, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            console.log(error);
            return false;
        }
    };

    const SendEmail = (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 18,
            "request_id": data.id,
        };
        axios.post(url, dataReq, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            // console.log(resp.data);
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="memo">
                    <Row>
                        <Col lg={12}>
                            <p className="memo-title">Request Detail {"> " + dataRequest.request_no}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <StepWorkflow step={6}/>
                        </Col>
                    </Row>
                    <Nav tabs className="nav nav-tabs nav-tabs-form nav-justified mb-3">
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "1",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("1");
                                }}
                            >
                                Request Form
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "2",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("2");
                                }}
                            >
                                Work Area
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "3",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("3");
                                }}
                            >
                                History
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent
                        activeTab={customActiveTab}
                    >
                        <TabPane tabId="1">
                            {SwitchRequestDetail()}
                        </TabPane>
                        <TabPane tabId="2">
                            <Row className="justify-content-center">
                                <Col sm={12} md={8} lg={6}>
                                    <Form className="needs-validation"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                    >
                                        <Row className="memo-select-div">
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <p className="memo-select-header">เอกสารแบบคำขอ (Request form)</p>
                                                    <Label className="memo-select-title">สามารถตรวจสอบเอกสารแบบคำได้ เพื่อความถูกต้องขอข้อมูล</Label>
                                                    <div className="form-download-multi">
                                                        <ul className="form-download-multi-ul">
                                                            <li className="form-download-multi-li">
                                                                <div className="form-download-multi-content" >
                                                                    <span>
                                                                        <label>Request No. {dataRequest.request_no}</label>
                                                                    </span>
                                                                    <i className="mdi mdi-pencil i-download" onClick={() => setIsShowModal(true) }></i>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="memo-select-div">
                                            <Col lg={12} >
                                                <p className="memo-select-header">โปรดเลือก.... Select ....</p>
                                                <FormGroup>
                                                    <Label className="memo-select-title">เลือกตัวเลือกสำหรับการจัดทำร่างเอกสารสุดท้าย (Select Document Finalization Option)<span className="msg-require">*</span></Label>
                                                    <div className="form-check">
                                                        <Input id="cbIsUserFinalDoc"
                                                            name="is_user_final_doc"
                                                            className="form-check-input memo-radio-input" 
                                                            type="radio"
                                                            checked={isUserFinalDoc === true}
                                                            onChange={() => {
                                                                setIsUserFinalDoc(true);
                                                                setDisableFileUserFinalDoc(false);
                                                                validation.handleChange('is_user_final_doc')("1");
                                                                validation.handleChange('final_doc')("");
                                                                setFileUserFinalDoc([]);
                                                                setFormIsDisabled(false);
                                                            }}
                                                            disabled={CheckDisableForm(true, "is_user_final_doc")}
                                                        />
                                                        <Label className="form-check-label memo-radio-label" for="cbIsUserFinalDoc">
                                                            คู่สัญญาอีกฝ่ายหนึ่งเป็นผู้จัดทำร่างเอกสารสุดท้าย (Counterparty finalize the document)
                                                            <p className="memo-radio-label-desc">หากเลือกให้คู่สัญญาอีกฝ่ายหนึ่งเป็นผู้จัดทำร่างเอกสารสุดท้าย กรุณาแนบเอกสาร (If you selected counterparty finalize the document, please attach.)</p>
                                                        </Label>
                                                        <SingleUploadfile inputID="userFinalDoc" folder={validation.values.request_no} dataFile={fileUserFinalDoc} setDataFile={OnSetFileUserFinalDoc} isDisable={disableFileUserFinalDoc} />
                                                        { validation.touched.final_doc && validation.errors.final_doc ? 
                                                            ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.final_doc}</FormFeedback> ) : false 
                                                        }
                                                    </div>
                                                    <div className="form-check memo-radio-space">
                                                        <Input id="cbIsLegalFinalDoc"
                                                            name="is_user_final_doc"
                                                            className="form-check-input memo-radio-input"
                                                            type="radio"
                                                            checked={isUserFinalDoc === false}
                                                            onChange={() => {
                                                                setIsUserFinalDoc(false);
                                                                setDisableFileUserFinalDoc(true);
                                                                validation.handleChange('is_user_final_doc')("0");
                                                                validation.handleChange('final_doc')("-");
                                                                setFileUserFinalDoc([]);
                                                                setFormIsDisabled(false);
                                                            }}
                                                            disabled={CheckDisableForm(false, "is_user_final_doc")}
                                                        />
                                                        <Label className="form-check-label memo-radio-label" for="cbIsLegalFinalDoc">
                                                            ทีมกฏหมายเป็นผู้จัดทำร่างเอกสารสุดท้าย (Legal team finalize the document)
                                                        </Label>
                                                    </div>
                                                    { validation.touched.is_user_final_doc && validation.errors.is_user_final_doc ? 
                                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.is_user_final_doc}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="memo-agreement-div">
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <p className="memo-agreement-label">เอกสารแนบสัญญา เช่น ภาคผนวกหรือ เอกสารแนบทางเทคนิค Attachment (Ex.Annex, Schedule or technical attachment)</p>
                                                    <MultipleUploadfile inputID="fileAgreementDoc" folder={validation.values.request_no} dataFile={fileAgreementDoc} setDataFile={OnSetFileAgreementDoc} isDisable={CheckDisableForm(true, "agreement_doc")} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <p className="memo-file-header">ดาวน์โหลดและแนบแบบฟอร์ม Memo (Download Memo form & Attach Memo)</p>
                                                <p className="memo-file-download-label">ดาวน์โหลดแบบฟอร์ม Memo (Download Memo Form)</p>
                                                <MultipleDownloadfile folder="memo" dataFile={templateMemo} />
                                                <p className="memo-file-upload-label">แนบ Memo สำหรับการเสนอลงนาม (Attach Memo For Signing Procedure)<span className="msg-require">*</span></p>
                                                <SingleUploadfile inputID="memoDoc" folder={validation.values.request_no} dataFile={fileMemoDoc} setDataFile={OnSetFileMemoDoc} isDisable={CheckDisableForm(true, "memo_doc")} />
                                                { validation.touched.memo_doc && validation.errors.memo_doc ? 
                                                    ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.memo_doc}</FormFeedback> ) : false 
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="memo-note-div">
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <Label className="memo-note-label" htmlFor="txtNote">Note</Label>
                                                    <Input id="txtNote"
                                                        name="note"
                                                        placeholder="Note"
                                                        type="textarea"
                                                        className="from-control memo-note-input"
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.note || ""}
                                                        invalid={ validation.touched.note && validation.errors.note ? true : false }
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="3">
                            <Row>
                                <Col md={12}>
                                    <div className="work-area-container-tab">
                                        <div className="header-container header-content">History</div>
                                        <div className="history-container">
                                            <RequestHistory
                                                data={requestHistory}
                                                column="do_date"
                                                requestNo={dataFormRequest.request_no}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                        <div className="page-footer">
                            <div className="layout-width-footer">
                                <div className="navbar-footer2">
                                    <Button type="button" className="memo-btn-back" onClick={(e) => { OnClickBack(); }}>
                                        Back
                                    </Button>
                                    <Button type="button" 
                                        color='primary' 
                                        className="memo-btn-submit"
                                        onClick={() => validation.submitForm()}
                                        disabled={formIsDisabled || customActiveTab !== "2"}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </TabContent>
                </Container>
            </div>
            <Modal id="modalEditForm"
                // className="modalEditForm"
                isOpen={isShowModal}
                toggle={() => { setIsShowModal(!isShowModal); }}
                backdrop={'static'}
                size="xl"
            >
                <ModalBody>
                    <Row>
                        <Col md={12} className="mx-auto">
                            <div className="d-flex justify-content-end">
                                <i className="mdi mdi-close-circle-outline modal-icon-close" onClick={() => setIsShowModal(false)}></i>
                            </div>
                            <div className="modal-user-information">
                                { checkShowInputUserCoordinator ? (
                                    <>
                                        <Row>
                                            <Col md={12}>
                                                <span className="span-type-request">ข้อมูลของผู้ทำคำขอ (User Information)</span>
                                            </Col>
                                        </Row>
                                        <Row className="pt-3">
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="request_label_nowrap">คำขอเลขที่ (Request No.)</Label>
                                                    <Input
                                                        type="text"
                                                        name="requestNo"
                                                        placeholder=""
                                                        // onChange={onInputChanged}
                                                        value={dataFormRequest.request_no || ''}
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="request_label_nowrap">วันที่สร้างคำขอ (Date of Request)</Label>
                                                    <Input
                                                    type="text"
                                                    name="dateOfRequest"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={dataFormRequest.request_date || ''}
                                                    disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="txtUserName" className="request_label">ผู้สร้างคำขอ (User's Create Request)</Label>
                                                    <Input
                                                    type="text"
                                                    name="businessUnit"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={userCreateRequest.name+" "+userCreateRequest.surname || ""}
                                                    disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="txtEmail" className="request_label">อีเมลผู้สร้างคำขอ (User's Create Request Email)</Label>
                                                    <Input
                                                    type="text"
                                                    name="department"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={userCreateRequest.email || ""}
                                                    disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="txtUserBu" className="request_label">บริษัทที่สังกัด (User's BU)</Label>
                                                    <Input
                                                        type="text"
                                                        name="businessUnit"
                                                        placeholder=""
                                                        // onChange={onInputChanged}
                                                        value={userCreateRequest?.business_unit || "-"}
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="txtUserDepartment" className="request_label">แผนกที่สังกัด (User's Department)</Label>
                                                    <Input
                                                        type="text"
                                                        name="department"
                                                        placeholder=""
                                                        // onChange={onInputChanged}
                                                        value={userCreateRequest.department || ""}
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <div className="line-border"></div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={12} className="mx-auto">
                                                <div>
                                                    <span className="span-type-request">ข้อมูลของผู้ประสานงาน (User Coordinator Information)</span>
                                                </div>
                                            </Col> 
                                        </Row>
                                        <Row className="pt-3">
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="coordinatorReq" className="request_label">ผู้ประสานงาน (User's Coordinator Request)</Label>
                                                    <Input
                                                    type="text"
                                                    name="businessUnit"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={dataUser.name + " " + dataUser.surname || "-" || ""}
                                                    disabled
                                                    />
                                                    {/* <Label className="request_label-val">
                                                        {dataCompany.name+" "+dataCompany.surname || ""}
                                                    </Label> */}
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="emailCoordinator" className="request_label">อีเมลผู้ประสานงาน (User's Coordinator Email)</Label>
                                                    <Input
                                                    type="text"
                                                    name="businessUnit"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={dataFormRequest.request_by || ""}
                                                    disabled
                                                    />
                                                    {/* <Label className="request_label-val">
                                                        {requestDataAll.request_by || ""}
                                                    </Label> */}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="ddlBu" className="request_label">บริษัทที่สังกัด (User's BU)</Label>
                                                    <Input
                                                    type="text"
                                                    name="businessUnit"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={userBuDetail.name_en || ""}
                                                    disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label htmlFor="ddlDepartment" className="request_label">แผนกที่สังกัด (User's Department)</Label>
                                                    <Input
                                                    type="text"
                                                    name="department"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={dataUser.department || ""}
                                                    disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </>
                                ):(
                                    <>
                                    <Row>
                                        <Col md={12}>
                                            <span className="span-type-request">ข้อมูลของผู้ทำคำขอ (User Information)</span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3">
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label className="request_label_nowrap">คำขอเลขที่ (Request No.)</Label>
                                                <Input
                                                    type="text"
                                                    name="requestNo"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={dataFormRequest.request_no || ''}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label className="request_label_nowrap">วันที่สร้างคำขอ (Date of Request)</Label>
                                                <Input
                                                type="text"
                                                name="dateOfRequest"
                                                placeholder=""
                                                // onChange={onInputChanged}
                                                value={dataFormRequest.request_date || ''}
                                                disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label htmlFor="txtUserName" className="request_label">ผู้ทำคำขอ (User’s Request)</Label>
                                                <Input
                                                type="text"
                                                name="businessUnit"
                                                placeholder=""
                                                // onChange={onInputChanged}
                                                value={dataUser.name + " " + dataUser.surname || "-" || ""}
                                                disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label htmlFor="txtEmail" className="request_label">อีเมลผู้ทำคำขอ (User’s email)</Label>
                                                <Input
                                                type="text"
                                                name="department"
                                                placeholder=""
                                                // onChange={onInputChanged}
                                                value={dataFormRequest.request_by || ""}
                                                disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label htmlFor="txtUserBu" className="request_label">บริษัทที่สังกัด (User's BU)</Label>
                                                <Input
                                                    type="text"
                                                    name="businessUnit"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={userBuDetail.name_en || "-"}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label htmlFor="txtUserDepartment" className="request_label">แผนกที่สังกัด (User's Department)</Label>
                                                <Input
                                                    type="text"
                                                    name="department"
                                                    placeholder=""
                                                    // onChange={onInputChanged}
                                                    value={dataUser.department || ""}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    </>
                                )}
                                <Row>
                                    <Col md={12}>
                                        <div className="line-border"></div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        { dataFormRequest.table_name?.toLowerCase() === "csa" ? (
                                            <RequestFormCsa dataFormCsa={dataForm} dataFormRequest={dataFormRequest} onSave={onSaveFormTrans} onCancelRequest={cancelRequest} />
                                        ): dataFormRequest.table_name?.toLowerCase() === "nda" ? (
                                            <RequestFormNda dataFormNda={dataForm} dataFormRequest={dataFormRequest} onSave={onSaveFormTrans} onCancelRequest={cancelRequest} />
                                        ): dataFormRequest.table_name?.toLowerCase() === "ldr" ? (
                                            <RequestFormLdr dataFormLdr={dataForm} dataFormRequest={dataFormRequest} onSave={onSaveFormTrans} onCancelRequest={cancelRequest} />
                                        ): dataFormRequest.table_name?.toLowerCase() === "dbd" ? (
                                            <RequestFormDbd dataFormDbd={dataForm} dataFormRequest={dataFormRequest} onSave={onSaveFormTrans} onCancelRequest={cancelRequest} />
                                        ): dataFormRequest.table_name?.toLowerCase() === "poa" ? (
                                            <RequestFormPoa dataFormPoa={dataForm} dataFormRequest={dataFormRequest} onSave={onSaveFormTrans} onCancelRequest={cancelRequest} />
                                        ): dataFormRequest.table_name?.toLowerCase() === "gct" ? (
                                            <RequestFormGct dataFormGct={dataForm} dataFormRequest={dataFormRequest} onSave={onSaveFormTrans} onCancelRequest={cancelRequest} />
                                        ):
                                        (
                                            <div>form other</div>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                        {/* <PdfExport dataForm={dataForm} dataFormRequest={dataFormRequest} dataUser={dataUser} /> */}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default Memo;